import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import ValidationError from "../validationError";
import {
  WorkflowType,
  WorkflowTypesWithLinkedDocuments
} from "~/enums/forms/workflowSteps/workflowType"
import {ErrorType} from "~/enums/ErrorType";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class PrePopulationValidator<T> extends NavigableValidator<WorkflowStep> {
  defaultMessage: 'must be published';
  defaultType = ErrorType.mustBePublished;

  get dependentDocFieldName(): string {
    return this.validatorKey;
  }

  _validate(model: WorkflowStep): void {
    if (WorkflowTypesWithLinkedDocuments.includes(model.workflow_type)) {
      let doc;
      switch(model.workflow_type){
        case WorkflowType.initialStep:
          doc= "Process Flow"
          break;
        default:
          doc = "Document"
      }
      //If the related document is present and not published
      if (model[this.dependentDocFieldName] && !model[this.dependentDocFieldName].is_published) {
        this.errors.push(this.buildValidationError(model,
          `Linked ${doc} in workflow must be published`,
          `${model.titleOrDefault} (step) - ${model[this.dependentDocFieldName].title} (Linked ${doc})`));
        //If the related document is not present
      }
    }
  }

  buildValidationError(model: WorkflowStep, value?, name? ,type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: name ||`${model.titleOrDefault} (step)`,
      errorNavOpts: model.validation.errorNavOpts(this, this.validatorKey, model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}